export const GET_QUOTE = 'get-quote';
const getQuote = ({ quoteId }) => ({ type: GET_QUOTE, payload: { quoteId } });
export default getQuote;
